import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import MobileCallBar from "@/components/MobileCallBar";
import HomePage from "@/pages/HomePage";
import ServicePage from "@/pages/ServicePage";
import AreaPage from "@/pages/AreaPage";
import ContactPage from "@/pages/ContactPage";
import { AREAS, SERVICES } from "@/data/site";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="min-h-screen bg-cream font-sans text-navy">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            {SERVICES.map((s) => (
              <Route key={s.slug} path={`/${s.slug}`} element={<ServicePage service={s} />} />
            ))}
            {AREAS.map((a) => (
              <Route key={a.slug} path={`/service-areas/${a.slug}`} element={<AreaPage area={a} />} />
            ))}
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </main>
        <Footer />
        <div className="h-[72px] md:hidden" aria-hidden="true" />
        <MobileCallBar />
        <Toaster position="top-center" richColors />
      </div>
    </BrowserRouter>
  );
}

export default App;
